// Its own type, so an ErrorHandler can tell a blocked third-party script apart from a fault in the app.
export class AssetLoadError extends Error {
  public override readonly name = 'AssetLoadError';

  public constructor(public readonly url: string) {
    super(`Asset could not be loaded dynamically: ${url}`);
  }
}
